import {createSelector} from 'reselect';
import {AppState} from '../../../index';

export const expenseLiabilitiesSelector = () =>
  createSelector(
    (state: AppState) => state.socialSupport.expenseLiabilities.liabilities,
    (item) => item,
  );
